import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import {
	CreateSecurityFormData,
	SubmitOptions,
} from '@dealstack/frontend/shared/components/CreateSecurityDrawer/CreateSecurityDrawer.types';
import { createSecurity } from '@dealstack/frontend/shared/dataExchange/services/securities';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { DataSecurityTct } from '@dealstack/shared/lib/generated';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';

export const useCreateNewSecurityDrawerController = (
	refreshSecuritiesList: () => void,
	onClose: (createdSecurityId?: string) => void
) => {
	const tCapManage = useTranslationCapManage();

	const { selectedEntityId } = useContext(CapManageControllerContext);

	const createSecurityRequest = useMutation({
		mutationFn: createSecurity,
	});

	const onCreate = (formValues: CreateSecurityFormData, options: SubmitOptions) => {
		createSecurityRequest.mutate(
			{ ...formValues, issuerId: selectedEntityId },
			{
				onSuccess: (createdSecurity: DataSecurityTct) => {
					options.resetForm();

					// Closing hands off to the directory, which needs the id to either highlight
					// the new row or toast with a jump-to-record action. It announces the create
					// itself, so toasting here as well would double it.
					if (options.shouldCloseOnSuccess) {
						onClose(createdSecurity.id);
						return;
					}

					refreshSecuritiesList();
					showToastV2({
						title: tCapManage('toasts.success.security_created_successfully'),
					});
				},
			}
		);
	};

	return {
		createSecurityRequest,
		onCreate,
	};
};
